import { Toolbar, AppBar, Box } from '@mui/material';

export const Header = () => (
  <Box sx={{ flexGrow: 1 }}>
    <AppBar color="transparent" position="static">
      <Toolbar>
        <Box component="img" src="./assets/images/Header_AverHealth_Logo.svg" alt="E-Reg Logo" sx={{ width: 150 }} />
      </Toolbar>
    </AppBar>
  </Box>
);
